import type { ReactNode } from "react";
import type { IconName } from "../assets/icons";
import { CountBadge } from "./CountBadge";
import { Icon } from "./Icon";
import { Tab } from "./TabHeader";
import { Text } from "./Text";

export function TabLink({
  to,
  active,
  replace,
  icon,
  label,
  count,
  children,
}: {
  to: string;
  active: boolean;
  replace?: boolean;
  icon: IconName;
  label: string;
  count?: number | null;
  children?: ReactNode;
}) {
  return (
    <Tab to={to} replace={replace} className={active ? "active" : ""}>
      <Icon name={icon} size={16} />
      <Text variant="text-small-md">{label}</Text>
      {children}
      {count != null && (
        <CountBadge>
          <Text variant="text-smaller-md">{count}</Text>
        </CountBadge>
      )}
    </Tab>
  );
}
